import { faqItems } from './faq-items-de.i18n';

export const de = {
  faqItems,
};